import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './assets/styles/font.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { CafeAdminModule } from './export';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from 'utils/sentry';

initSentry();

async function startApp() {
  if (process.env.REACT_APP_ENABLE_MOCKS === 'true') {
    const { worker } = await import('./mocks/browser');
    await worker.start({ onUnhandledRequest: 'warn' });
  }

  const root = ReactDOM.createRoot(document.getElementById('root'), {
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  });
  root.render(
    <BrowserRouter>
      <CafeAdminModule />
    </BrowserRouter>
  );
}

startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
